module.exports = (function () {
    // this will not work for Header and Footer on legacy pages, as they are considered
    // to be the same on all pages and their `location` is considered as `home page` always

    const localeUtils = require('utils/LanguageLocale');
    const PageTemplateType = require('constants/PageTemplateType');

    let Location = {};
    const basketURL = /^\/basket*/;
    const productReviewsPageURL = /^\/reviews*/;
    const addReviewPageURL = /^\/addReview*/;
    const CUSTOM_SETS_HASH = '#customsets';
    const referrerURL = /^\/share/;

    function sanitizePathname(location) {
        const locationCopy = { ...location };
        locationCopy.pathname = locationCopy.pathname && locationCopy.pathname.replace(/ca\/en\/|ca\/fr\//g, '');
        return locationCopy;
    }

    function getLocation(sanitize = false) {
        return (
            Sephora.location ?
                sanitize ? sanitizePathname(Sephora.location) : Sephora.location
                :
                !Sephora.isNodeRender ?
                    sanitize ? sanitizePathname(window.location) : window.location
                    :
                    { pathname: '' }
        );
    }

    function setLocation(url) {
        let location = Location.getLocation();
        location.href = url;
    }

    function isBasketPage() {
        let location = Location.getLocation(true);
        return location.pathname && !!location.pathname.match(basketURL);
    }

    function isOffersPage() {
        return Sephora.renderQueryParams.urlPath === '%2Fbeauty%2Fbeauty-offers';
    }

    function isHolidayPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/beauty/holiday-sale') !== -1;
    }

    function isProductReviewsPage() {
        let location = Location.getLocation(true);
        return location.pathname &&
            !!location.pathname.match(productReviewsPageURL);
    }

    function isAddReviewPage() {
        let location = Location.getLocation(true);
        return location.pathname && !!location.pathname.match(addReviewPageURL);
    }

    function isGalleryPage() {
        return Sephora.pagePath === PageTemplateType.Gallery;
    }

    function isGalleryAlbumPage() {
        let location = Location.getLocation(true);
        return /\/gallery\/album\/.*/.test(location.pathname);
    }

    function isCustomSets(hash) {
        return new RegExp(CUSTOM_SETS_HASH).test(hash || Location.getLocation().hash);
    }

    function isMyProfilePage() {
        let location = Location.getLocation();
        return location.pathname.indexOf('/profile/me') !== -1;
    }

    function isAccountPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/account') === 0 ||
            location.pathname.indexOf('/profile/MyAccount') === 0;
    }

    function isRichProfilePage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/profile') === 0;
    }

    function isCheckout() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/checkout') === 0;
    }

    function isPlayEdit() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/playedit') === 0;
    }

    function isPlayQuiz() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/beauty/play-quiz') === 0;
    }

    function isPreview() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/preview') === 0;
    }

    function isPreviewSettings() {
        return Sephora.pagePath === PageTemplateType.PreviewSettings;
    }

    function isProd() {
        let location = Location.getLocation();
        return location.href.match(/(www|m)\.sephora\.com/) !== null;
    }

    function isBrandNthCategoryPage() {
        return Sephora.pagePath === PageTemplateType.BrandNthCategory;
    }

    function isHomePage() {
        return Sephora.pagePath === PageTemplateType.Homepage;
    }

    function isRootCategoryPage() {
        return Sephora.pagePath === PageTemplateType.Category;
    }

    function isNthCategoryPage() {
        return Sephora.pagePath === PageTemplateType.NthCategory;
    }

    function isProductPage() {
        return Sephora.pagePath === PageTemplateType.ProductPage;
    }

    function isPublicLovesPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/lovelist') === 0;
    }

    function isOrderConfirmationPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/checkout/confirmation') === 0;
    }

    function isGalleryProfilePage() {
        let location = Location.getLocation(true);
        return (location.pathname === '/myprofile' ||
            location.pathname === '/myprofile/photos' ||
            location.pathname === '/gallery/myprofile/photos' ||
            location.pathname === '/gallery/myprofile/loved');
    }

    function isContentStorePage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/beauty/') === 0 &&
            !Location.isContactUsPage() &&
            !Location.isPlayQuiz() &&
            !Location.isOrderStatusPage();
    }

    function isCreditCardApplyPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/creditcard-apply') === 0;
    }

    function isCreditCardTabPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/profile/CreditCard') === 0;
    }

    function isCreditCardMarketingPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/creditcard') === 0;
    }

    function isSearchPage() {
        return Sephora.pagePath === PageTemplateType.Search;
    }

    function isNoSearchResultsPage() {
        return Sephora.pagePath === PageTemplateType.ZeroSearchResults;
    }

    function isBIPage() {
        return Sephora.pagePath === PageTemplateType.BeautyInsider;
    }

    function isTargetedLandingPage() {
        return Sephora.pagePath === PageTemplateType.BeautyWinPromo;
    }

    function isBIRBPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/rewards') === 0;
    }

    function isSalePage() {
        let location = Location.getLocation(true);
        return location.pathname === '/sale';
    }

    function isOnlineReservationLandingPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/happening/home') === 0;
    }

    function isContactUsPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/beauty/contact-us') === 0;
    }

    function isOrderStatusPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/beauty/order-status') === 0;
    }

    function isPurchaseHistoryPage() {
        return Sephora.pagePath === PageTemplateType.PurchaseHistory;
    }

    function isLovesListPage() {
        return Sephora.pagePath === PageTemplateType.ShoppingList;
    }

    function isReferrerPage() {
        let location = Location.getLocation(true);
        return location.pathname && !!location.pathname.match(referrerURL);
    }

    function reload() {
        window.location.reload();
    }

    function isExperienceDetailsPage() {
        let location = Location.getLocation(true);
        return location.pathname.indexOf('/happening/classes') === 0 ||
            location.pathname.indexOf('/happening/services') === 0 ||
            location.pathname.indexOf('/happening/events') === 0 ||
            location.pathname.indexOf('/happening/announcements') === 0;
    }

    function getPageTitle(template) {
        let getText = localeUtils.getLocaleResourceFile('utils/locales', 'Location');

        const pagesTitles = {
            [PageTemplateType.BrandsList]: getText('brandsList'),
            [PageTemplateType.Lists]: getText('lists'),
            [PageTemplateType.ShoppingList]: getText('lovesList'),
            [PageTemplateType.PurchaseHistory]: getText('purchaseHistory'),
            [PageTemplateType.InstoreServices]: getText('inStoreServices'),
            [PageTemplateType.AddReviewPage]: getText('writeAReview'),
            [PageTemplateType.Confirmation]: getText('orderConfirmation'),
            [PageTemplateType.OrderDetails]: getText('orderDetail'),
            [PageTemplateType.Profile]: getText('profile'),
            [PageTemplateType.BeautyInsider]: getText('beautyInsider'),
            [PageTemplateType.MyAccount]: getText('myAccount'),
            [PageTemplateType.Orders]: getText('recentOrders'),
            [PageTemplateType.Subscriptions]: getText('subscriptions'),
            [PageTemplateType.MyReservations]: getText('reservations'),
            [PageTemplateType.Addresses]: getText('savedAddresses'),
            [PageTemplateType.PaymentMethods]: getText('paymentsAndCredits'),
            [PageTemplateType.EmailPostal]: getText('emailAndMailPreferences'),
            [PageTemplateType.Community]: getText('beautyForum'),
            [PageTemplateType.Gallery]: getText('gallery'),
            [PageTemplateType.AddPhoto]: getText('addPhoto'),
            [PageTemplateType.Departments]: getText('sitemapDepartments')
        };

        return pagesTitles[template];
    }

    function isVendorLoginPage() {
        return Sephora.pagePath === PageTemplateType.VendorLogin;
    }

    function isVendorGenericLogin() {
        return Sephora.pagePath === PageTemplateType.VendorGenericLogin;
    }

    function updateSeoCanonicalUrl(seoCanonicalUrl) {
        const { SEPHORA_URL } = require('components/constants');
        const { getLink } = require('utils/Url');

        const seoCanonicalUrlLink = document.getElementById('seoCanonicalUrl');
        if (seoCanonicalUrlLink) {
            seoCanonicalUrlLink.setAttribute('href', getLink(`${SEPHORA_URL.DESKTOP}${seoCanonicalUrl}`));
        }

    }

    function isConstructorEnabledPage() {
        const constructorDisabledPages = [
            PageTemplateType.Checkout,
            PageTemplateType.MyAccount,
            PageTemplateType.PaymentMethods,
            PageTemplateType.Addresses
        ];
        return constructorDisabledPages.indexOf(Sephora.pagePath) === -1;
    }

    Location = {
        isAccountPage,
        isBasketPage,
        isOffersPage,
        isBrandNthCategoryPage,
        isProductReviewsPage,
        isAddReviewPage,
        isMyProfilePage,
        isRichProfilePage,
        isRootCategoryPage,
        isNthCategoryPage,
        isPreview,
        isProd,
        isCheckout,
        isPlayEdit,
        isPlayQuiz,
        isOrderStatusPage,
        isPurchaseHistoryPage,
        isHomePage,
        isGalleryPage,
        isProductPage,
        isGalleryProfilePage,
        isContentStorePage,
        isSearchPage,
        isNoSearchResultsPage,
        isGalleryAlbumPage,
        isOrderConfirmationPage,
        isPublicLovesPage,
        isCustomSets,
        isBIPage,
        isBIRBPage,
        getLocation,
        setLocation,
        isCreditCardApplyPage,
        isCreditCardTabPage,
        isCreditCardMarketingPage,
        isSalePage,
        isOnlineReservationLandingPage,
        isTargetedLandingPage,
        isContactUsPage,
        isLovesListPage,
        isReferrerPage,
        reload,
        isExperienceDetailsPage,
        PAGES: { CUSTOM_SETS_HASH: CUSTOM_SETS_HASH },
        getPageTitle,
        sanitizePathname,
        isVendorLoginPage,
        isVendorGenericLogin,
        updateSeoCanonicalUrl,
        isPreviewSettings,
        isConstructorEnabledPage,
        isHolidayPage
    };

    return Location;
}());
